import {
    cloneDeep,
    util,
    isCorrectVal,
    isDate,
    lg
} from 'utils';
import services from "./services";
import Uploader from 'uploader';
import areaSelect from 'area-select';
import viewPhoto from 'src/common/js/viewPhoto';
import linkInfo from 'link-info';
import $http from '$http'
import {
    Message
} from 'element-ui';

export default {
    mixins: [services],
    components: {
        'area-select': areaSelect,
        'link-info': linkInfo
    },
    data() {
        return {
            flagStatus: false, //首次编辑进来来接口，防止被watch情况数据
            isReadOnly: false,
            openClass: false,
            Audit: false,
            SubjectList: [], //项目类型
            areaInfo: this.getAreaData(),
            areaInfo2: this.getAreaData(),
            dialogVisible: false, //转正
            form: this.getFormData(),
            uploadSwitch: true,
            SchoolPic: [],
            PermitPic: [],
            contractPic: [],
            equipmentPic: [],
            ApplyPicList: [], //平台开通申请表
            dialogImageUrl: "",
            PictureVisible: false,
            SchoolStatus: "", //学校状态，根据该字段判断是否调用转正接口
            settings: {},
            C_name: '',
            C_email: '',
            C_QQ: '',
            C_position: '',
            rules: {
                Consignee: [{
                    required: true,
                    message: '请输入收货人姓名',
                    trigger: 'blur'
                }],
                ConsigneeTel: [{
                    required: true,
                    message: '请填写收货人电话',
                    trigger: 'blur'
                }],
                ConsigneeAdress: [{
                    required: true,
                    message: '请输入收货地址',
                    trigger: 'blur'
                }],
            },
            cloneServercontactList: [],
            contactList: [],
            visiable: this.value,
            ProjectType: [], //项目类型
            Myshort: [],
            PolicyType: [], //政策类型
            PolicyList: [],
            MyPolicy: [],
            submitform: this.getSubmitForm(),
            auditList: [{
                id: "2",
                text: "审核通过"
            }, {
                id: "1",
                text: "审核不通过"
            }],
            tabRadioId: 1,
            SchoolContract: {
                NetworkOperatorName: [],
                BandWidth: '',
                IsSpecilLine: '',
                NetworkType: [],
                ProvePics: [], //app申请 上传的图片
                ProveType: '',
                ContractPices: [], //app申请的合同款图片
                DistanceName: '',
                EngineerName: ''
            },
            ApplyType: '' //1 合同审核 2 开课申请表审核

        }
    },
    props: {
        Id: {
            default: "",
        }
    },
    methods: {
        getAreaData() {
            return cloneDeep({
                Provinces_Id: '',
                City_Id: '',
                Area_Id: ''
            });

        },
        getSetting() {
            return cloneDeep({
                id: "",
                official: false, //转正
                Audit: false, //审核
                changeForm: false, //正式幼儿园修改
                isReadOnly: false,
                openClass: false //开课
            });
        },
        getSubmitForm() {
            return cloneDeep({
                Id: "",
                AuditStatus: "",
                AuditOpinion: "",
                TimeStamp: ''
            });
        },
        getFormData() {
            return cloneDeep({
                "AgentId": 0,
                "SchoolName": "",
                "Address": "",
                "ProvId": 0,
                "CityId": 0,
                "AreaId": 0,
                "SchoolId": 0,
                "PhoneNo": "",
                "SchoolPhoneNo": "", //园所电话
                "ProjectType": "",
                "PolicyType": "",
                "ChildNum": "",
                "Tuition": "",
                "ContactList": [],
                "Id": 0,
                "hnd_CooperationPics": "",
                "hnd_EquipPics": "",
                "Tel": "", //园所电话
                "hnc_drawing": "",
                "hndbond_drawing": "",
                "Email": "",
                "QQ": "",
                "Weixin": "",
                "PrincipalName": "",
                "DataType": 0,
                "ProjectTypes": "",
                "Consignee": "",
                "ConsigneeTel": "",
                "ConsigneeProvince": 0,
                "ConsigneeCity": 0,
                "ConsigneeArea": 0,
                "ConsigneeAdress": "",
                "AuditStatusName": "",
                "PolicyTypes": "",
                "C_name": '',
                "C_email": '',
                "C_tel": "",
                "C_weixin": "",
                "IsExperience": 0
            });
        },
        //添加联系人信息信息
        addContactObj() {
            this.contactList.push({});
        },
        changeProjectType(item) {
            if (!this.flagStatus) {
                this.PolicyType = [];
            }
            this.req_getPolicy(item.join(","))
        },
        delContactfn(item) {
            this.$confirm('确定要删除该联系人，删除后不可恢复？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.contactList.splice((item.index - 2), 1);
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        },
        /*转正 审核 查看 修改*/
        Regularization(options) {
            this.flagStatus = true;
            console.log(options)
            let opts = Object.assign({}, this.getSetting(), options);

            this.settings = opts;
            this.dialogVisible = true;
            this.isReadOnly = opts.isReadOnly;
            this.openClass = opts.openClass;
            this.form.Id = opts.id;
            this.Audit = opts.Audit;
            //console.log(this.settings)
            if (this.Audit || options.isAuditView) {
                this.ApplyType = options.ApplyType
                //只有审核管理入口进来的需要传OrderId
                this.GetSchoolModel(this.form.Id, true);
            } else {
                this.GetSchoolModel(this.form.Id);
            }


            if (this.uploadSwitch) {
                this.uploadSwitch = false;

                this.$nextTick(function () {
                    var self = this;
                    let uploaderFactory = new Uploader();
                    let uploader1 = uploaderFactory.generator({
                        container: 'container-1',
                        browse_button: 'upload-btn-1',
                        multi_selection: true,
                        //开始上传
                        uploadBegin: function () {

                        },
                        //上传结束并得到文件
                        uploaded: function (file) {
                            self.SchoolPic.push(file)
                        }
                    });

                    let uploader2 = uploaderFactory.generator({
                        container: 'container-2',
                        browse_button: 'upload-btn-2',
                        multi_selection: true, //是否允许多文件上传
                        uploadBegin: function () {

                        },
                        uploaded: function (file) {
                            self.PermitPic.push(file)
                        }
                    });

                    let uploader3 = uploaderFactory.generator({
                        container: 'container-3',
                        browse_button: 'upload-btn-3',
                        multi_selection: true, //是否允许多文件上传
                        uploadBegin: function () {

                        },
                        uploaded: function (file) {
                            self.contractPic.push(file)
                        }
                    });
                    let uploader4 = uploaderFactory.generator({
                        container: 'container-4',
                        browse_button: 'upload-btn-4',
                        multi_selection: true, //是否允许多文件上传
                        uploadBegin: function () {

                        },
                        uploaded: function (file) {
                            self.equipmentPic.push(file)
                        }
                    });
                    uploaderFactory.init();
                });
            }
        },
        dialogClose() {
            this.dialogVisible = false;
            this.isReadOnly = false;
            this.form = this.getFormData();
            //this.$refs["ruleForm"].resetFields();
            this.$refs.myareaForm.resetFields();
            this.areaInfo2 = this.getAreaData()
            this.SchoolPic = [];
            this.PermitPic = [];
            this.contractPic = [];
            this.equipmentPic = [];
            this.submitform = this.getSubmitForm();
        },
        viewPicture(url, list) {
            viewPhoto.show({
                showImgId: "", //指定id显示图片
                thumbList: [{
                    src: url,
                    id: ""
                }]
            });
        },
        delPicture(Url, list) {
            if (list.length > 0) {
                for (var i = 0; i < list.length; i++) {
                    if (list[i].Url == Url) {
                        list.splice(i, 1);
                    }
                }
            }
        },
        clearData() {
            this.form = (this.getFormData());
        },
        officialSubmit() {
            if (this.form.DataType == 0) {
                this.form.IsExperience = ''
            }


            this.form.hnc_drawing = this.SchoolPic.map(item => item.Url).toString();
            this.form.hndbond_drawing = this.PermitPic.map(item => item.Url).toString();
            this.form.hnd_CooperationPics = this.contractPic.map(item => item.Url).toString();
            this.form.hnd_EquipPics = this.equipmentPic.map(item => item.Url).toString();
            let address = this.$refs.myareaForm.validate();
            let address2 = this.$refs.myareaForm2.validate();

            if (address2) {
                this.areaInfo2 = address2
            }
            this.form.ProvId = this.areaInfo2.Provinces_Id;
            this.form.CityId = this.areaInfo2.City_Id;
            this.form.AreaId = this.areaInfo2.Area_Id;
            // console.log(this.areaInfo2)
            // console.log(address2)
            if (!!address) {
                this.form.ConsigneeProvince = address.Provinces_Id;
                this.form.ConsigneeCity = address.City_Id;
                this.form.ConsigneeArea = address.Area_Id;
            }

            this.form.ProjectType = this.ProjectType.join(",");
            this.form.ProjectTypes = this.form.ProjectType;
            // 只有联帮在线没有政策类型
            if (this.form.ProjectTypes.indexOf(1) !== -1) {
                this.form.PolicyType = '';
            } else {
                this.form.PolicyType = this.PolicyType.join(",");
            }

            let ListAgentAreas = [];
            var obj = {};
            obj.C_name = this.form.C_name
            obj.C_email = this.form.C_email
            obj.C_tel = this.form.C_tel
            obj.C_weixin = this.form.C_weixin

            ListAgentAreas.push(obj);
            this.cloneServercontactList.splice(0, 1)
            for (let i = 0; i < this.cloneServercontactList.length; i++) {
                ListAgentAreas.push(this.cloneServercontactList[i]);
            }
            for (let i = 0; i < this.contactList.length; i++) {
                let data = this.$refs['contactInfo' + (i + 1)][0].validate();
                if (!data) {
                    return;
                }
                ListAgentAreas.push(data);
            }
            //console.log(ListAgentAreas)
            this.form.ContactList = ListAgentAreas;
            // if (this.SubjectList.length > 0) {
            //     if ($.trim(this.form.ProjectType).length == 0) {
            //         this.$notify({
            //             title: '警告',
            //             message: "请选择项目类型",
            //             type: 'warning'
            //         });
            //         return;
            //     }
            // }

            // if (this.PolicyList.length > 0) {
            //     if ($.trim(this.form.PolicyType).length == 0) {
            //         this.$notify({
            //             title: '警告',
            //             message: "请选择政策类型",
            //             type: 'warning'
            //         });
            //         return;
            //     }
            // }

            this.$refs["ruleForm"].validate((valid) => {

                if (this.settings.Audit) {
                    // 审核

                    this.submitform.Id = this.form.Id;

                    // if (this.form.AuditStatusName == "待审核" || this.form.AuditStatusName == "未审核通过") {}

                    let rules = [];
                    rules.push({
                        name: "审核信息",
                        value: this.submitform.AuditStatus,
                        required: true
                    });
                    rules.push({
                        name: "意见内容",
                        value: this.submitform.AuditOpinion,
                        required: true
                    });

                    let flag = util.checkForm({
                        ele: this,
                        rules: rules
                    });

                    if (!flag) {
                        return;
                    }

                    this.CheckSchoolApply();

                } else if (this.settings.changeForm) {
                    // 修改
                    //console.log(this.form)
                    this.changeForm(this.form);

                } else if (valid && address && this.settings.official) {

                    // 转正
                    if (this.SchoolStatus == "正常" || this.SchoolStatus == "延期" || this.SchoolStatus == "驳回" || this.SchoolStatus == '新增') {
                        //console.log(this.form)
                        this.officalSumit(this.form);

                    } else {
                        this.$notify({
                            title: "警告",
                            message: "该客户为" + this.SchoolStatus + ",无法继续进行转正!",
                            type: 'warning'
                        })
                    }
                } else {
                    return false;
                }
            });
        }

    },
    computed: {
        sysSid: function () {
            return this.$store.state.sysSid;
        },
        sysSession: function () {
            return this.$store.state.sysSession;
        },
        AgentList() {
            return this.$store.state.AgentList;
        }
    },
    mounted() {
        this.$store.dispatch("getAgentList");
    },
    watch: {
        value: function (val) {
            this.visiable = this.value;
            if (val) {
                this.GetSchoolModel();
            }
        },
        visiable: function (val) {
            this.$emit('input', val);
            if (!val) {
                //this.$refs.baseInfo.resetFields();
                for (let i = 0; i < this.contactList.length; i++) {
                    this.$refs['contactInfo' + (i + 1)][0].resetFields();
                }
                this.contactList = [];
            }
        },
        "form.AgentId" () {
            if (!this.flagStatus) {
                this.SubjectList = [];
                this.ProjectType = [];
            }
            this.$nextTick(function () {

                this.req_getProjectType();
            });
        },
    }
}


// WEBPACK FOOTER //
// ./src/pages/school/components/official/vm.js